import React, { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Modal,
  Button,
  Col,
  Row,
  Form,
  Container,
  Card,
  Image,
} from "react-bootstrap";
import ReactToPrint from "react-to-print";
import styled from "styled-components";
import QRCode from "qrcode.react";
import Barcode from "react-barcode";
import THBText from "thai-baht-text";
import SpinnerLoading from "../../components/Loading/SpinnerLoading";
import ModalPayment from "./ModalPayment";
import ModalPolicy, { PolicyPage } from "./ModalPolicy";
import SVG from "react-inlinesvg";
import $ from "jquery";

import { useCompanyPkindev } from "../../hook/useCompanyPkindev";
import { useCustomerProject } from "../../hook/useCustomerProject";
import { useBillSetting } from "../../hook/useBillSetting";
import { useContractAgreement } from "../../hook/useContractAgreement";
import { useBillPaymentMutation } from "../../hook/useBillPayment";
import { use } from "react";
import { notification, Result, Card as AntCard } from 'antd';


const StyledWrapper = styled.div`
  display: flex;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;

  input[type="checkbox"] {
    width: 20px;
    height: 20px;
  }
  @media screen {
    .policy_page {
      display: none;
    }
  }

`;



const dataCompany = {
  name_company: "",
  name_company_en: "",
  name_branch: "",
  head_office: 0,
  address: "",
  address_en: "",
  address2: "",
  address2_en: "",
  id_country: 66,
  id_province: "",
  id_district: "",
  id_subdistrict: "",
  postal_code: "",
  website: "",
  phone_no: "",
  ext_no: "",
  fax_no: "",
  email: "",
  id_tax: "",
  icon_company_url: "",
  textlogo_company_url: "",
  authsignature_company_url: "",
  stamp_company_url: "",
  cash: { check: 0 },
  credit: { public_key: "", secret_key: "", check: 0, enable: 0, status: "" },
  paypal: {
    account: "",
    client_id: "",
    secret: "",
    check: 0,
    enable: 0,
    status: "",
  },
  bill: {
    check: 0,
    enable: 0,
    bank: {
      suffix_key: "",
      prefix_ref1: "",
      prefix_ref2: "",
      check: 0,
      bank_detail: [],
    },
    lotus: { check: 0 },
  },
  transfer: {
    id_bank: "",
    branch_name: "",
    account_name: "",
    account_type: "",
    account_number: "",
    photo_upload: { name: "Upload", url: null },
    check: 0,
    enable: 0,
  },
};
const dataInvoice = {
  name_project: "",
  quotation_no: "",
  product_detail: [
    {
      name_product: "",
      price_per_unit: "",
      qty: "",
      unit: "",
      discount: "",
      discount_type: "",
      description: "",
      total: "",
    },
  ],
  subtotal: "",
  discount: "",
  discount_type: "",
  vat: "",
  total: "",
  total_amount: "",
  issue_date: "",
  due_date: "",
  remark: "",
  barcode_tesco: "",
  idWithHoldingTax: "",
  holding_tax_price: "",
  status: "",
  purchase_order_no: "",
  contract_rows: [],
  subscription_plan: null,
};
const dataCustomer = {
  customer_code: "",
  name_company: "",
  detail_type: "",
  head_office: 0,
  name_branch: "",
  name_personal: "",
  id_name_title: "",
  name_organization: "",
  name_staff: "",
  address: "",
  address2: "",
  id_country: 66,
  id_province: "",
  id_district: "",
  id_subdistrict: "",
  postal_code: "",
  id_tax: "",
  id_passport: "",
  phone_no: "",
  fax_no: "",
  email: "",
  privacy_policy: "",
  privacy_policy_issue_date: "",
  refundable_policy: "",
  refundable_policy_issue_date: "",
  terms_conditions: "",
  terms_conditions_issue_date: "",
};


// ==================== MOCK DATA ====================
const mockCompany = {
  ...dataCompany,
  name_company: "N/A",
  name_company_en: "N/A",
  name_branch: "N/A",
  head_office: 0,
  address: "N/A",
  address_en: "N/A",
  id_province: "",
  id_district: "",
  id_subdistrict: "",
  postal_code: "N/A",
  phone_no: "N/A",
  fax_no: "N/A",
  email: "N/A",
  id_tax: "N/A",
  icon_company_url: "",
  textlogo_company_url: "",
  authsignature_company_url: "",
  stamp_company_url: "",
  cash: { check: 0 },
  credit: { public_key: "", secret_key: "", check: 0, enable: 0, status: "" },
  paypal: { account: "", client_id: "", secret: "", check: 0, enable: 0, status: "" },
  bill: {
    check: 0,
    enable: 0,
    bank: { suffix_key: "", prefix_ref1: "", prefix_ref2: "", check: 0, bank_detail: [] },
    lotus: { check: 0 },
  },
  transfer: {
    id_bank: "",
    branch_name: "N/A",
    account_name: "N/A",
    account_type: "N/A",
    account_number: "N/A",
    photo_upload: { name: "Upload", url: null },
    check: 0,
    enable: 0,
  },
};

const mockInvoice = {
  ...dataInvoice,
  name_project: "N/A",
  quotation_no: "",
  invoice_no: "N/A",
  contract_no: "N/A",
  issue_date: "",
  due_date: "",
  status: "N/A",
  type: "",
  product_detail: [],
  subtotal: 0,
  discount: 0,
  discount_type: "Baht",
  vat: 0,
  total: 0,
  total_amount: 0,
  idWithHoldingTax: "",
  holding_tax_price: 0,
  remark: "N/A",
  purchase_order_no: "",
  customer_code: "",
  customer_name: "",
  customer_phone_no: "",
};

const mockCustomer = {
  ...dataCustomer,
  customer_code: "",
  name_company: "N/A",
  detail_type: "company",
  head_office: 0,
  name_branch: "N/A",
  name_personal: "",
  id_name_title: "",
  name_organization: "",
  name_staff: "",
  address: "N/A",
  address2: "",
  id_country: 66,
  id_province: "",
  id_district: "",
  id_subdistrict: "",
  postal_code: "N/A",
  id_tax: "N/A",
  id_passport: "",
  phone_no: "N/A",
  fax_no: "",
  email: "N/A",
  privacy_policy: "",
  privacy_policy_issue_date: "",
  refundable_policy: "",
  refundable_policy_issue_date: "",
  terms_conditions: "",
  terms_conditions_issue_date: "",
};

// Mock province/district/subdistrict data
  // const mockSelectProvince = [
  //   { value: "", label1: "Bangkok", label2: "กรุงเทพมหานคร" },
  // ];
  // const mockSelectDistrict = [
  //   { value: "", label1: "Amphoe Watthana", label2: "เขตวัฒนา" },
  // ];
  // const mockSelectSubDistrict = [
  //   { value: "", label1: "Khlong Toei Nuea", label2: "แขวงคลองเตยเหนือ" },
  // ];
  // const mockNameTitle = [
  // ];
  // const mockWidthholdingtax = [
  //   { value: "1", label: "(3%)" },
  // ];
  // const mockBankPayment = [
  //   { id_bank: "004", name_bank_th: "ธนาคารกสิกรไทย", bank_icon: "", bank_icon_noBG: "" },
  // ];


// ==================== COMPONENT ====================
const BillingProject = () => {
  const ref = useRef();
  const { id_project, id_invoice } = useParams();

// useCompanyPkindev
const { 
  data: companyData, 
  isLoading: isCompanyLoading, 
  isError: isCompanyError 
} = useCompanyPkindev({ id_company: 70 })

// useBillSetting
const { bank_payment, creditBank, project_detail, NameTitle, WithHoldingTax, province, district, subDistrict } = useBillSetting({ id_project, lang: "both" })
// useContractAgreement
const { 
  data: contractAgreementData, 
  isLoading: isContractAgreementLoading, 
  isError: isContractAgreementError,
  error: contractAgreementError
} = useContractAgreement({ id_project, id_invoice })
// console.log('contractAgreementData ::', contractAgreementData)
// console.log('contractRow ::', contractAgreementData?.contractRow)
// console.log('customer_code ::', contractAgreementData?.customerCode)
// console.log('customer_invoice_data ::', contractAgreementData?.customer_invoice_data)
// console.log('InvoicePolicyManagrment ::', contractAgreementData?.InvoicePolicyManagrment)


  const { sendBillSlip, sendOmise } = useBillPaymentMutation();

  const [dataInfoCompany, setdataInfoCompany] = useState(mockCompany);
  const [dataInfoInvoice, setdataInfoInvoice] = useState(mockInvoice);
  const [dataInfoCustomer, setdataInfoCustomer] = useState(mockCustomer);
  const [modalShowPolicy, setmodalShowPolicy] = useState(false);
  const [modalShowPayment, setmodalShowPayment] = useState(false);
  const [policy_subject, setpolicy_subject] = useState("");
  const [policy_text, setpolicy_text] = useState({ th: "", en: "" });
  const [policy_content, setpolicy_content] = useState({ text: "", date: "" });
  const [agreePay, setagreePay] = useState(false);
  const [modalShowVerifyId, setmodalShowVerifyId] = useState(false);
  const [verifyIdInput, setVerifyIdInput] = useState("");
  const [verifyIdError, setVerifyIdError] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const isPaymentLoading = sendBillSlip.isPending || sendOmise.isPending;
  const isLoading = isCompanyLoading || isContractAgreementLoading || isPaymentLoading;



  useEffect(() => {
    if (companyData && companyData.length > 0) {
      setdataInfoCompany(companyData[0])  // ← เอาแค่ index 0
    }
  }, [companyData])

  useEffect(() => {
    if (!contractAgreementData) return

    const { contractRow, customer_invoice_data, InvoicePolicyManagrment, subscription_plan, customerCode } = contractAgreementData
    const policy = InvoicePolicyManagrment?.[0]

    // normalize contractRow → array เสมอ (รองรับทั้ง object เดียว และ array)
    const contractRows = Array.isArray(contractRow) ? contractRow : (contractRow ? [contractRow] : [])
    const projectInfo = project_detail?.data?.[0] ?? null

    // ── map dataInfoInvoice ──────────────────────────────────
    if (contractRows.length > 0) {
      const first = contractRows[0]
      setdataInfoInvoice(prev => ({
        ...prev,
        name_project:      projectInfo?.name_project        ?? "",
        invoice_no :       first.id_invoice              ?? "",
        issue_date:        first.invoice_issued_date   ?? "",
        contract_no:       first.contract_no           ?? "",
        due_date:          first.due_date              ?? "",
        remark:            first.remark                ?? "",
        status:            first.status_payment        ?? "",
        idWithHoldingTax:  first.idWithHoldingTax      ?? "",
        holding_tax_price: first.holding_tax_price     ?? "",
        barcode_tesco:     first.barcode_tesco         ?? "",
        id_contract_agreement: first.id_contract_agreement ?? "",
        id_project :        id_project         ?? "",
        // ยอดรวมทั้งหมดทุก rows
        subtotal:     contractRows.reduce((sum, r) => sum + (parseFloat(r.price)          || 0), 0),
        discount:     contractRows.reduce((sum, r) => sum + (parseFloat(r.discount_price) || 0), 0),
        total:        contractRows.reduce((sum, r) => sum + (parseFloat(r.total_price)    || 0), 0),
        total_amount: contractRows.reduce((sum, r) => sum + (parseFloat(r.total_amount)   || 0), 0),
        vat:          0,  // contractRow ไม่มี vat field → reset เป็น 0 เสมอ
        // เก็บ rows ทั้งหมดไว้แสดงในตาราง
        contract_rows: contractRows,
        // subscription plan จาก API
        subscription_plan: subscription_plan ?? null,
      }))

    }

    // ── map dataInfoCustomer ─────────────────────────────────
    if (customer_invoice_data) {

      


      setdataInfoCustomer(prev => ({
        ...prev,
        customer_code:  customerCode?.customer_code ?? "",
        name_company:   customer_invoice_data.name_company   ?? "",     
        name_personal:  customer_invoice_data.name_personal  ?? "",  
        id_name_title:  customer_invoice_data.id_name_title ?? "",
        name_organization : customer_invoice_data.name_organization ?? "",
        name_branch:    customer_invoice_data.name_branch    ?? "",
        head_office:    customer_invoice_data.head_office    ?? 0,
        address:        customer_invoice_data.address        ?? "",
        address2:       customer_invoice_data.address2       ?? "",
        id_province:    customer_invoice_data.id_province    ?? "",
        id_district:    customer_invoice_data.id_district    ?? "",
        id_subdistrict: customer_invoice_data.id_subdistrict ?? "",
        postal_code:    customer_invoice_data.postal_code    ?? "",
        id_tax:         customer_invoice_data.id_tax         ?? "",
        id_passport:    customer_invoice_data.id_passport    ?? "",
        phone_no:       customer_invoice_data.phone_no       ?? "",
        fax_no:         customer_invoice_data.fax_no         ?? "",
        email:          customer_invoice_data.email          ?? "",
        detail_type:    customer_invoice_data.detail_type    ?? "company",
        // policy
        terms_conditions:             policy?.terms_conditions             ?? "",
        terms_conditions_issue_date:  policy?.terms_conditions_issue_date  ?? "",
        privacy_policy:               policy?.privacy_policy               ?? "",
        privacy_policy_issue_date:    policy?.privacy_policy_issue_date    ?? "",
        refundable_policy:            policy?.refundable_policy            ?? "",
        refundable_policy_issue_date: policy?.refundable_policy_issue_date ?? "",
      }))



      // ✅ Validate tax ID และเปิด Modal ยืนยันตัวตนอัตโนมัติ
      const detailType = customer_invoice_data.detail_type ?? "company"
      const idTax      = customer_invoice_data.id_tax      ?? ""
      const idPassport = customer_invoice_data.id_passport ?? ""

      if (detailType === "company" && !idTax) {
        notification.error({
          message: "ข้อมูลไม่ครบถ้วน",
          description: "ไม่พบเลขประจำตัวผู้เสียภาษี (Tax ID) กรุณาติดต่อฝ่ายสนับสนุน",
          duration: 0,
        })
      } else if (detailType === "personal" && !idPassport) {
        notification.error({
          message: "ข้อมูลไม่ครบถ้วน",
          description: "ไม่พบเลขบัตรประชาชน / Passport กรุณาติดต่อฝ่ายสนับสนุน",
          duration: 0,
        })
      } else {
        setmodalShowVerifyId(true)
      }
    }

  }, [contractAgreementData, project_detail?.data])



  const provinceList    = province.data    || [];
  const districtList    = district.data    || [];
  const subDistrictList = subDistrict.data || [];
  const nameTitleList   = NameTitle.data   || [];
  const withholdingList = WithHoldingTax.data || [];

  // props (แทน Redux)
  const props = {
    selectProvince:    provinceList,
    selectDistrict:    districtList,
    selectSubDistrict: subDistrictList,
    selectProvince1:   provinceList,
    selectDistrict1:   districtList,
    selectSubDistrict1: subDistrictList,
    nameTitle:         nameTitleList,
    widthholdingtax:   withholdingList,
    bankPayment:       bank_payment.data || [],
    selectCreditBank:  creditBank.data || [],
    loading: false,
  };

  const numberWithCommas = (x) => {
    return parseFloat(x)
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const set_date = (data, joinwith) => {
    // guard: ถ้า null/undefined/empty → ใช้วันปัจจุบัน
    let date = new Date();
    if (data != null && data !== "") {
      const parsed = new Date(data);
      if (!isNaN(parsed.getTime())) date = parsed; // valid date เท่านั้น
    }
    const time1 = [
      Intl.DateTimeFormat("en-US", { day: "2-digit" }).format(date),
      Intl.DateTimeFormat("en-US", { month: "2-digit" }).format(date),
      Intl.DateTimeFormat("en-US", { year: "numeric" }).format(date),
    ];
    return time1.join(joinwith ? joinwith : "-");
  };
  
  const set_time = (data) => {
    let date = new Date();
    if (data != "") date = new Date(data);
    return date.getTime();
  };

  const formatNumBank = (data) => {
    return `${data.slice(0, 3)}-${data.slice(3, 4)}-${data.slice(
      4,
      9
    )}-${data.slice(9, 10)}`;
  };




  const ErrorCard = ({ title, description }) => (
    <StyledWrapper>
      <AntCard style={{ borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
        <Result
          status="error"
          title={title}
          subTitle={description}
        />
      </AntCard>
    </StyledWrapper>
  );
  
  if (isContractAgreementError) {
    const errStatus = contractAgreementError?.response?.status;
    if (errStatus === 400) return <ErrorCard title="โปรเจกต์นี้ยังไม่พร้อมใช้งาน" description="กรุณาติดต่อผู้ดูแลระบบ" />;
    if (errStatus === 404) return <ErrorCard title="ไม่พบข้อมูล Invoice" description="กรุณาตรวจสอบลิงก์หรือติดต่อผู้ดูแลระบบ" />;
    return <ErrorCard title="เกิดข้อผิดพลาด" description="กรุณาลองใหม่อีกครั้ง" />;
  }




  if (isContractAgreementError) {
    const errStatus = contractAgreementError?.response?.status;
    if (errStatus === 400) return <ErrorCard title="โปรเจกต์นี้ยังไม่พร้อมใช้งาน" description="กรุณาติดต่อผู้ดูแลระบบ" />;
    if (errStatus === 404) return <ErrorCard title="ไม่พบข้อมูล Invoice" description="กรุณาตรวจสอบลิงก์หรือติดต่อผู้ดูแลระบบ" />;
    return <ErrorCard title="เกิดข้อผิดพลาด" description="กรุณาลองใหม่อีกครั้ง" />;
  }


  return (
    <>  
      

      <SpinnerLoading modal={isLoading} />
      <Image src="/media/PKINDEV PLATFORM/LOGO/INVOIZE_LOGO.png" height="80" />
      <StyledWrapper>
        <div style={{ filter: isVerified ? "none" : "blur(6px)", userSelect: isVerified ? "auto" : "none", pointerEvents: isVerified ? "auto" : "none", width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Card style={{ overflow: "auto", maxHeight: "80%", maxWidth: "80%" }}>
          <Card.Body ref={ref}>
            <div className="crop_content" style={{ minWidth: "1100px" }}>
              <Row style={{ minWidth: "900px" }}>
                <Col xs={5} className="pr-0">
                  <p
                    style={{
                      marginTop: "25px",
                      fontSize: "12.5px",
                      whiteSpace: "nowrap",
                      color: "black",
                    }}
                  >
                    {dataInfoCompany?.name_company_en?.toUpperCase() ?? "N/A"}
                    <br />
                    {dataInfoCompany?.name_company ?? "N/A "}
                    <br />
                    {`${dataInfoCompany?.address_en ?? "N/A "}, ${
                      props.selectSubDistrict.length != 0 &&
                      dataInfoCompany?.id_subdistrict != ""
                        ? props.selectSubDistrict.find(
                            (doc) => doc.value == dataInfoCompany?.id_subdistrict
                          )?.label1 ?? dataInfoCompany?.id_subdistrict
                        : "N/A"
                    }, ${
                      props.selectDistrict.length !== 0 &&
                      dataInfoCompany?.id_district != ""
                        ? props.selectDistrict
                            .find(
                              (doc) => doc.value == dataInfoCompany?.id_district
                            )
                            ?.label1?.split("Amphoe")[1] ?? "N/A Amphoe"
                        : "N/A Amphoe" 
                    }, ${
                      props.selectProvince.length !== 0 &&
                      dataInfoCompany?.id_province != ""
                        ? props.selectProvince.find(
                            (doc) => doc.value == dataInfoCompany?.id_province
                          )?.label1 ?? "N/A id_province"
                        : "N/A id_province"
                    }  Thailand ${dataInfoCompany?.postal_code ?? "N/A postal_code" } `}
                    <br />
                    {`${dataInfoCompany?.address ?? "N/A"} ตำบล${
                      props.selectSubDistrict.length != 0 &&
                      dataInfoCompany?.id_subdistrict != ""
                        ? props.selectSubDistrict.find(
                            (doc) => doc.value == dataInfoCompany?.id_subdistrict
                          )?.label2 ?? ""
                        : ""
                    } ${
                      props.selectDistrict.length != 0 &&
                      dataInfoCompany?.id_district != ""
                        ? props.selectDistrict.find(
                            (doc) => doc.value == dataInfoCompany?.id_district
                          )?.label2 ?? ""
                        : ""
                    } จังหวัด${
                      props.selectProvince.length != 0 &&
                      dataInfoCompany?.id_province != ""
                        ? props.selectProvince.find(
                            (doc) => doc.value == dataInfoCompany?.id_province
                          )?.label2 ?? ""
                        : ""
                    } ${dataInfoCompany?.postal_code ?? ""}`}
                    <br />
                    {`Tel : ${dataInfoCompany?.phone_no ?? "N/A"} Fax : ${dataInfoCompany?.fax_no ?? "N/A"}`}
                    <br />
                    {`เลขประจําตัวผู้เสียภาษีอากร : ${
                      dataInfoCompany?.id_tax ?? "N/A"
                    } สาขาประกอบการ ${
                      dataInfoCompany?.head_office
                        ? "สํานักงานใหญ่"
                        : dataInfoCompany?.name_branch ?? "N/A"
                    }`}
                    <br />
                    {`TAX ID : ${dataInfoCompany?.id_tax ?? "N/A"} Branch No. : ${
                      dataInfoCompany?.head_office
                        ? "Head Office"
                        : dataInfoCompany?.name_branch ?? "N/A"
                    }`}
                  </p>
                </Col>
                <Col xs={2} className="p-0">
                  <h4
                    style={{
                      whiteSpace: "nowrap",
                      marginLeft: "-15px",
                      marginBottom: "15px",
                      color: "black",
                    }}
                    className="text-center"
                  >
                    INVOICE{" "}
                    {dataInfoInvoice?.type && dataInfoInvoice?.type == "ABB"
                      ? "(ABB)"
                      : ""}
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;ใบวางบิล / ใบแจ้งหนี้
                  </h4>
                </Col>

                {/* {console.log("dataInfoCompany", dataInfoCompany)} */}

                <Col xs={5}>
                  <div className="text-right mr-4">
                    <Image
                      src={dataInfoCompany?.icon_company_url}
                      style={{ maxWidth: "100%", maxHeight: "80px" }}
                    />
                    <Image
                      src={dataInfoCompany?.textlogo_company_url}
                      style={{ maxWidth: "45%", maxHeight: "100px" }}
                    />
                  </div>
                  <Row>
                    <Col xs={6}></Col>
                    <Col xs={6}>
                      <h4
                        class="pl-4 pr-4 pb-2 pt-2 text-center mt-2"
                        style={{
                          paddingLeft: "50px",
                          border: "1px solid black",
                          color: "black",
                        }}
                      >
                        ต้นฉบับ/ Original
                      </h4>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row style={{ minWidth: "900px" }}>
                <Col xs={5} className="pr-0">
                  <div
                    className="pl-3 pr-3 pb-1 pt-1"
                    style={{
                      border: "1px solid black",
                      borderRadius: "10px",
                    }}
                  >
                    <p
                      className="m-1"
                      style={{ fontSize: "12.5px", color: "black" }}
                    >
                      รหัสลูกค้า/CUSTOMER NO. :&nbsp;
                      <b>
                        {dataInfoCompany?.bill.bank.prefix_ref1}
                        {dataInfoInvoice?.type && dataInfoInvoice?.type == "ABB"
                          ? dataInfoInvoice?.customer_code
                          : dataInfoCustomer?.customer_code}
                      </b>
                    </p>
                    <p
                      className="m-1"
                      style={{ fontSize: "12.5px", color: "black" }}
                    >
                      ชื่อลูกค้า/CUSTOMER NAME :&nbsp;
                      <b>
                        {dataInfoInvoice?.type && dataInfoInvoice?.type == "ABB"
                          ? dataInfoInvoice?.customer_name
                          : dataInfoCustomer?.name_company != ""
                          ? dataInfoCustomer?.name_company
                          : dataInfoCustomer?.name_personal != ""
                          ? `${
                              props.nameTitle.length !== 0 &&
                              dataInfoCustomer?.id_name_title != ""
                                ? props.nameTitle.find(
                                    (doc) =>
                                      doc.value ==
                                      dataInfoCustomer?.id_name_title
                                  )?.label2 || ""
                                : null
                            } ${dataInfoCustomer?.name_personal}`
                          : dataInfoCustomer?.name_organization}
                      </b>
                    </p>
                    {dataInfoCustomer?.detail_type != "personal" ? (
                      <p
                        className="m-1"
                        style={{ fontSize: "12.5px", color: "black" }}
                      >
                        สาขา/BRANCH NO. :&nbsp;
                        <b>
                          {dataInfoCustomer?.head_office
                            ? "สำนักงานใหญ่"
                            : dataInfoCustomer?.name_branch}
                        </b>
                      </p>
                    ) : null}
                    {true ? (
                      <p
                        className="m-1"
                        style={{ fontSize: "12.5px", color: "black" }}
                      >
                        ที่อยู่/ADDRESS :&nbsp;
                        <b>
                          {`${dataInfoCustomer?.address} ${dataInfoCustomer?.id_province == 10 ? " " : "ตำบล"}${
                            props.selectSubDistrict1.length != 0 &&
                            dataInfoCustomer?.id_subdistrict != ""
                              ? props.selectSubDistrict1.find(
                                  (doc) =>
                                    doc.value == dataInfoCustomer?.id_subdistrict
                                )?.label2 || ""
                              : null
                          } ${
                            props.selectDistrict1.length != 0 &&
                            dataInfoCustomer?.id_district != ""
                              ? props.selectDistrict1.find(
                                  (doc) =>
                                    doc.value === dataInfoCustomer?.id_district
                                )?.label2 || ""
                              : null
                          } ${dataInfoCustomer?.id_province == 10 ? " " : "จังหวัด"}${
                            props.selectProvince1.length != 0 &&
                            dataInfoCustomer?.id_province != ""
                              ? props.selectProvince1.find(
                                  (doc) =>
                                    doc.value == dataInfoCustomer?.id_province
                                )?.label2 || ""
                              : ""
                          } ${dataInfoCustomer?.postal_code}`}
                        </b>
                      </p>
                    ) : (
                      ""
                    )}
                    <p
                      className="m-1"
                      style={{ fontSize: "12.5px", color: "black" }}
                    >
                      เบอร์ติดต่อ/TEL NO. :&nbsp;
                      <b>
                        {dataInfoInvoice?.type && dataInfoInvoice?.type == "ABB"
                          ? dataInfoInvoice?.customer_phone_no
                          : dataInfoCustomer?.phone_no}
                      </b>
                    </p>
                    {true ? (
                      <p
                        className="m-1"
                        style={{ fontSize: "12.5px", color: "black" }}
                      >
                        {dataInfoCustomer?.detail_type !== "personal"
                          ? "เลขประจำตัวผู้เสียภาษีอากร/TAX ID. :"
                          : "เลขประจำตัวประชาชน/ID Card No. :"}
                        &nbsp;
                        <b>
                          {dataInfoCustomer?.detail_type != "personal"
                            ? dataInfoCustomer?.id_tax
                            : dataInfoCustomer?.id_passport}
                        </b>
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </Col>
                <Col xs={2}></Col>
                <Col xs={5}>
                  <div
                    className="p-1"
                    style={{
                      fontSize: "12.5px",
                      position: "static",
                      border: "1px solid black",
                    }}
                  >
                    <p
                      className="m-1"
                      style={{ fontSize: "12.5px", color: "black" }}
                    >
                      ใบวางบิลเลขที่/Invoice No. :&nbsp;
                      <b>{dataInfoInvoice?.invoice_no}</b>
                    </p>
                    <p
                      className="m-1"
                      style={{ fontSize: "12.5px", color: "black" }}
                    >
                      วันที่วางบิล/Issued Date :&nbsp;
                      <b>{set_date(dataInfoInvoice?.issue_date)}</b>
                    </p>
                    <p
                      className="m-1"
                      style={{ fontSize: "12.5px", color: "black" }}
                    >
                      สัญญาเลขที่/Contract No. :&nbsp;
                      <b>
                        {dataInfoCompany?.bill.bank.prefix_ref2}
                        {dataInfoInvoice?.contract_no}
                      </b>
                    </p>
                    <p
                      className="m-1"
                      style={{ fontSize: "12.5px", color: "black" }}
                    >
                      วันครบกำหนดชำระ/Due Date :&nbsp;
                      <b>{set_date(dataInfoInvoice?.due_date)}</b>
                    </p>
                  </div>
                
                  <div
                    className="p-1 mt-2"
                    style={{
                      fontSize: "12.5px",
                      position: "static",
                      border: "1px solid black",
                      color: "black",
                    }}
                  >

                    {dataInfoInvoice?.payment_type && (
                      <>
                        รูปแบบการชำระเงิน/Payment Type. : {dataInfoInvoice.payment_type}
                        <b></b>
                        <br />
                      </>
                    )}
                      
                    กำหนดชำระ/CREDIT TERM :&nbsp;
                    <b>
                      {set_time(dataInfoInvoice?.due_date) -
                        set_time(dataInfoInvoice?.invoice_issued_date) >
                      0
                        ? `${parseInt(
                            (set_time(dataInfoInvoice?.due_date) -
                              set_time(dataInfoInvoice?.invoice_issued_date)) /
                              (1000 * 60 * 60 * 24)
                          )} วัน/Day(s)`
                        : "วันนี้/Today"}
                    </b>
                    <br />
                    {dataInfoInvoice?.purchase_order_no
                      ? "ใบสั่งซื้อเลขที่/Purchase Order No. : "
                      : null}
                    {dataInfoInvoice?.purchase_order_no ? (
                      <b>{dataInfoInvoice?.purchase_order_no}</b>
                    ) : null}
                  </div>

                </Col>
              </Row>
              <label style={{ color: "black" }} className="mt-3">
                ชื่อโปรเจค/Project Name : <b>{dataInfoInvoice?.name_project}</b>
              </label>
              <table
                style={{
                  fontSize: "12.5px",
                  color: "black",
                  minWidth: "100%",
                }}
                className="mb-0"
              >
                <tbody className="text-center">
                  <tr>
                    <td
                      style={{
                        border: "1px solid black",
                        borderRight: 0,
                        borderBottom: 0,
                      }}
                      width="5%"
                    >
                      รายการ
                      <br />
                      No.
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        borderRight: 0,
                        borderBottom: 0,
                      }}
                      width="15%"
                    >
                      ชื่อสินค้า
                      <br />
                      Product Name
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        borderRight: 0,
                        borderBottom: 0,
                      }}
                      width="25%"
                    >
                      รายละเอียด
                      <br />
                      Description
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        borderRight: 0,
                        borderBottom: 0,
                      }}
                      width="15%"
                    >
                      ระยะเวลา
                      <br />
                      Period
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        borderRight: 0,
                        borderBottom: 0,
                      }}
                      width="15%"
                    >
                      ราคาต่อหน่วย
                      <br />
                      Price per Unit
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        borderRight: 0,
                        borderBottom: 0,
                      }}
                      width="15%"
                    >
                      ส่วนลด
                      <br />
                      Discount
                    </td>
                    <td
                      style={{ border: "1px solid black", borderBottom: 0 }}
                      width="15%"
                    >
                      ราคา
                      <br />
                      Price
                    </td>
                  </tr>
                  {(dataInfoInvoice?.contract_rows ?? []).map((row, index) => {
                    const discountVal = parseFloat(row.discount_price) || 0
                    return (
                      <tr key={row.id_contract_agreement ?? index}>
                        <td
                          style={{ border: "1px solid black", borderRight: 0 }}
                          height="40px"
                        >
                          <b>{index + 1}</b>
                        </td>
                        <td
                          style={{ border: "1px solid black", borderRight: 0 }}
                        >
                          <b>
                            {dataInfoInvoice?.subscription_plan?.name_subscription_plan ?? row.remark ?? "-"}
                          </b>
                        </td>
                        <td
                          style={{ border: "1px solid black", borderRight: 0 }}
                        >
                          <b>
                            {dataInfoInvoice?.subscription_plan?.subscription_plan_detail
                              ? dataInfoInvoice.subscription_plan.subscription_plan_detail.join(", ")
                              : "-"}
                          </b>
                        </td>
                        <td
                          style={{ border: "1px solid black", borderRight: 0 }}
                        >
                          <b>
                            {set_date(row.start_date, "/")} - {set_date(row.finish_date, "/")}
                            <br />
                            <small>({row.period_time ?? 1} Month{(row.period_time ?? 1) > 1 ? "s" : ""})</small>
                          </b>
                        </td>
                        <td
                          style={{ border: "1px solid black", borderRight: 0 }}
                        >
                          <b>{numberWithCommas(row.price ?? "0")}</b>
                        </td>
                        <td
                          style={{ border: "1px solid black", borderRight: 0 }}
                        >
                          <b>{discountVal > 0 ? numberWithCommas(row.discount_price) : "0.00"}</b>
                        </td>
                        <td style={{ border: "1px solid black" }}>
                          <b>{numberWithCommas(row.total_price ?? row.price ?? "0")}</b>
                        </td>
                      </tr>
                    );
                  })}
                  <tr>
                    <td
                      class="border-0"
                      style={{
                        border: 0,
                        textAlign: "left",
                      }}
                      colSpan="5"
                    >
                      <b> จำนวนเงินรวมทั้งสิ้น/Total :</b>{" "}
                      {THBText(dataInfoInvoice?.total ?? 0)}
                    </td>
                    <td
                      class="border-0"
                      style={{ border: 0, textAlign: "right" }}
                    >
                      รวมเป็นเงิน/Subtotal :&nbsp;
                    </td>
                    <td
                      style={{ border: "1px solid black", borderTop: 0 }}
                      height="40px"
                    >
                      <b>{numberWithCommas(dataInfoInvoice?.subtotal ?? 0)}</b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="border-0 align-top"
                      style={{
                        border: 0,
                        textAlign: "left",
                        whiteSpace: "pre-line",
                      }}
                      colSpan="5"
                      rowspan="3"
                    >
                      <b>หมายเหตุ/Remark(s)</b> : {dataInfoInvoice?.remark}
                    </td>
                    <td
                      class="border-0"
                      style={{ border: 0, textAlign: "right" }}
                    >
                      ส่วนลด/Discount :&nbsp;
                    </td>
                    <td
                      style={{ border: "1px solid black", borderTop: 0 }}
                      height="40px"
                    >
                      <b>
                        {(parseFloat(dataInfoInvoice?.discount) || 0) > 0
                          ? numberWithCommas(dataInfoInvoice?.discount)
                          : "0.00"}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="border-0"
                      style={{ border: 0, textAlign: "right" }}
                    >
                      ภาษีมูลค่าเพิ่ม/VAT (7%) :&nbsp;
                    </td>
                    <td
                      style={{ border: "1px solid black", borderTop: 0 }}
                      height="40px"
                    >
                      <b>{numberWithCommas(dataInfoInvoice?.vat ?? 0)}</b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="border-0"
                      style={{ border: 0, textAlign: "right" }}
                    >
                      จำนวนเงินรวมทั้งสิ้น/Total :&nbsp;
                    </td>
                    <td
                      style={{ border: "1px solid black", borderTop: 0 }}
                      height="40px"
                    >
                      <b>{numberWithCommas(dataInfoInvoice?.total ?? 0)}</b>
                    </td>
                  </tr>
                  <tr>
                    <td class="border-0" colSpan="6"></td>
                    <td class="border-0" style={{ verticalAlign: "top" }}>
                      <div
                        class="mt-1"
                        style={{ border: "1px solid black", borderTop: 0 }}
                      ></div>
                    </td>
                  </tr>
                  {dataInfoInvoice?.idWithHoldingTax != "" ? (
                    <>
                      <tr>
                        <td class="border-0" colSpan="5"></td>
                        <td class="border-0" colSpan="3">
                          <div
                            class="mt-2 mb-2"
                            style={{ border: "1px dashed black", borderTop: 0 }}
                          ></div>
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="border-0"
                          style={{ border: 0, textAlign: "left" }}
                          colSpan="5"
                        ></td>
                        <td
                          class="border-0"
                          colSpan="2"
                          style={{ border: 0, textAlign: "right" }}
                        >
                          ภาษีหัก ณ ที่จ่าย / Withholding Tax{" "}
                          {dataInfoInvoice?.idWithHoldingTax != "" &&
                          props.widthholdingtax.length != 0
                            ? props.widthholdingtax.find(
                                (doc) =>
                                  doc.value == dataInfoInvoice?.idWithHoldingTax
                              )?.label ?? ""
                            : null}{" "}
                          :&nbsp;
                        </td>
                        <td style={{ border: "1px solid black" }} height="40px">
                          <b>
                            {numberWithCommas(
                              dataInfoInvoice?.holding_tax_price
                            )}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="border-0"
                          style={{ border: 0, textAlign: "left" }}
                          colSpan="5"
                        ></td>
                        <td
                          class="border-0"
                          colSpan="2"
                          style={{ border: 0, textAlign: "right" }}
                        >
                          ยอดชำระ / Payment Amount :&nbsp;
                        </td>
                        <td style={{ border: "1px solid black" }} height="40px">
                          <b>
                            {numberWithCommas(dataInfoInvoice?.total_amount)}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td class="border-0" colSpan="6"></td>
                        <td class="border-0" style={{ verticalAlign: "top" }}>
                          <div
                            class="mt-1"
                            style={{ border: "1px solid black", borderTop: 0 }}
                          ></div>
                        </td>
                      </tr>
                    </>
                  ) : null}
                </tbody>
              </table>
              <table
                style={{
                  fontSize: "12.5px",
                  color: "black",
                  minWidth: "100%",
                }}
                className="mb-0 mt-4"
              >
                <tbody className="text-center">
                  <tr>
                    <td
                      style={{
                        border: "1px solid black",
                        borderRight: 0,
                      }}
                      width="30%"
                    >
                      <div style={{ padding: "10px" }}>
                        <div style={{ textAlign: "left" }}>
                          {dataInfoCompany?.name_company}
                        </div>
                        <div className="mt-2">
                          <Image
                            src={dataInfoCompany?.authsignature_company_url}
                            style={{
                              width: "60px",
                              position: "absolute",
                              marginLeft: "-5%",
                            }}
                          />
                          <Image
                            src={dataInfoCompany?.stamp_company_url}
                            style={{
                              width: "140px",
                              position: "absolute",
                              marginLeft: "2%",
                              marginTop: "-2%",
                            }}
                          />
                        </div>
                        <div
                          className="mt-5"
                          style={{
                            borderTop: "2px dotted  black",
                            padding: "5px",
                          }}
                        >
                          ผู้วางบิล
                        </div>
                      </div>
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        borderRight: `${
                          dataInfoCompany?.transfer.enable ? 0 : 1
                        }`,
                      }}
                      width="30%"
                    >
                      <div style={{ padding: "10px" }}>
                        <div style={{ textAlign: "left" }}>รับทราบ</div>
                        <div className="mt-2"></div>
                        <div
                          className="mt-5"
                          style={{
                            borderTop: "2px dotted  black",
                            padding: "5px",
                          }}
                        >
                          ผู้รับวางบิล
                        </div>
                      </div>
                    </td>
                    {dataInfoCompany?.transfer.enable ? (
                      <td
                        style={{
                          border: "1px solid black",
                        }}
                        width="40%"
                      >
                        <div style={{ padding: "10px" }}>
                          <div style={{ textAlign: "left" }}>
                            สำหรับโอนเงิน{" "}
                            {props.bankPayment.length != 0 &&
                            dataInfoCompany?.transfer.id_bank != ""
                              ? props.bankPayment.find((doc) => doc.id_bank == dataInfoCompany?.transfer.id_bank)?.name_bank_th ?? "N/A"
                              : null}{" "}
                            {dataInfoCompany?.transfer.branch_name != ""
                              ? `สาขา ${dataInfoCompany?.transfer.branch_name}`
                              : null}
                          </div>
                          <div className="mt-1">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                flexWrap: "wrap",
                              }}
                            >
                              <div>
                                <Image
                                  src={
                                    props.bankPayment.length != 0 &&
                                    dataInfoCompany?.transfer?.id_bank != ""
                                      ? `data:image/png;base64,${
                                          props.bankPayment.find(
                                            (doc) =>
                                              doc.id_bank ==
                                              dataInfoCompany?.transfer?.id_bank
                                          )?.bank_icon ?? ""
                                        }`
                                      : null
                                  }
                                  height="80"
                                />
                              </div>
                              <div style={{ maxWidth: "200px" }}>
                                {dataInfoCompany?.transfer?.account_name ?? "N/A"}
                                <br />
                                {dataInfoCompany?.transfer?.account_number
                                  ? formatNumBank(dataInfoCompany.transfer.account_number)
                                  : "N/A"}
                                <br />
                                {dataInfoCompany?.transfer?.account_type ?? "N/A"}
                              </div>
                              <div>
                                {dataInfoCompany?.transfer?.photo_upload?.url !=
                                null ? (
                                  <Image
                                    src={
                                      dataInfoCompany?.transfer?.photo_upload?.url
                                    }
                                    height="80"
                                  />
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    ) : null}
                  </tr>
                </tbody>
              </table>

              {/* ======================================== Line ====================================================== */}
              {dataInfoCompany?.bill.enable ? (
                <div className="billPayPage">
                  <div style={{ minWidth: "900px" }}>
                    <div
                      style={{
                        borderTop: "2px dashed black",
                        marginTop: "1.5rem",
                      }}
                    ></div>

                    <Row className="mt-4">
                      <Col xs={5} className="pr-0">
                        <Col xs={9} className="pl-0">
                          <div style={{ marginBottom: "4rem", color: "black" }}>
                            <p
                              className="pl-4 pr-4 pb-1 pt-1 text-center"
                              style={{ border: "1px solid black" }}
                            >
                              สำหรับธนาคาร (For Bank Use Only)
                            </p>
                          </div>
                        </Col>
                        <p
                          style={{
                            marginTop: "25px",
                            fontSize: "12.5px",
                            whiteSpace: "nowrap",
                            color: "black",
                          }}
                        >
                          {dataInfoCompany?.name_company_en?.toUpperCase() ?? "N/A"}
                          <br />
                          {dataInfoCompany?.name_company ?? "N/A"}
                          <br />
                          {`${dataInfoCompany?.address_en ?? "N/A"}, ${
                            props.selectSubDistrict.length != 0 &&
                            dataInfoCompany?.id_subdistrict != ""
                              ? props.selectSubDistrict.find(
                                  (doc) =>
                                    doc.value == dataInfoCompany?.id_subdistrict
                                )?.label1 ?? "N/A"
                              : "N/A"
                          }, ${
                            props.selectDistrict.length != 0 &&
                            dataInfoCompany?.id_district != ""
                              ? props.selectDistrict
                                  .find(
                                    (doc) =>
                                      doc.value == dataInfoCompany?.id_district
                                  )
                                  ?.label1?.split("Amphoe")[1] ?? "N/A"
                              : "N/A"
                          }, ${
                            props.selectProvince.length != 0 &&
                            dataInfoCompany?.id_province != ""
                              ? props.selectProvince.find(
                                  (doc) =>
                                    doc.value == dataInfoCompany?.id_province
                                )?.label1 ?? "N/A"
                              : "N/A"
                          }  Thailand ${dataInfoCompany?.postal_code ?? "N/A"} `}
                          <br />
                          {`${dataInfoCompany?.address ?? "N/A"} ตำบล${
                            props.selectSubDistrict.length != 0 &&
                            dataInfoCompany?.id_subdistrict != ""
                              ? props.selectSubDistrict.find(
                                  (doc) =>
                                    doc.value == dataInfoCompany?.id_subdistrict
                                )?.label2 ?? ""
                              : ""
                          } ${
                            props.selectDistrict.length != 0 &&
                            dataInfoCompany?.id_district != ""
                              ? props.selectDistrict.find(
                                  (doc) =>
                                    doc.value == dataInfoCompany?.id_district
                                )?.label2 ?? ""
                              : ""
                          } จังหวัด${
                            props.selectProvince.length != 0 &&
                            dataInfoCompany?.id_province != ""
                              ? props.selectProvince.find(
                                  (doc) =>
                                    doc.value == dataInfoCompany?.id_province
                                )?.label2 ?? ""
                              : ""
                          } ${dataInfoCompany?.postal_code ?? ""}`}
                          <br />
                          {`Tel : ${dataInfoCompany?.phone_no ?? "N/A"} Fax : ${dataInfoCompany?.fax_no ?? "N/A"}`}
                          <br />
                          {`เลขประจําตัวผู้เสียภาษีอากร : ${
                            dataInfoCompany?.id_tax ?? "N/A"
                          } สาขาประกอบการ ${
                            dataInfoCompany?.head_office
                              ? "สํานักงานใหญ่"
                              : dataInfoCompany?.name_branch ?? "N/A"
                          }`}
                          <br />
                          {`TAX ID : ${dataInfoCompany?.id_tax ?? "N/A"} Branch No. : ${
                            dataInfoCompany?.head_office
                              ? "Head Office"
                              : dataInfoCompany?.name_branch ?? "N/A"
                          }`}
                        </p>
                      </Col>
                      <Col xs={2} className="p-0"></Col>
                      <Col xs={5}>
                        <div className="text-right mr-4">
                          <Image
                            src={dataInfoCompany?.icon_company_url}
                            style={{ maxWidth: "100%", maxHeight: "80px" }}
                          />
                          <Image
                            src={dataInfoCompany?.textlogo_company_url}
                            style={{ maxWidth: "45%", maxHeight: "100px" }}
                          />
                        </div>
                        <div
                          className="p-1 mt-2"
                          style={{
                            fontSize: "12px",
                            position: "static",
                            border: "1px solid black",
                          }}
                        >
                          <p
                            className="m-1"
                            style={{ fontSize: "12.5px", color: "black" }}
                          >
                            วันที่ชำระ/Payment Date :&nbsp;
                          </p>
                          <p
                            className="m-1"
                            style={{ fontSize: "12.5px", color: "black" }}
                          >
                            ชื่อลูกค้า/Company Name :&nbsp;
                            <b>
                              {dataInfoCustomer?.name_company != ""
                                ? dataInfoCustomer?.name_company
                                : dataInfoCustomer?.name_personal != ""
                                ? dataInfoCustomer?.name_personal
                                : dataInfoCustomer?.name_organization}
                            </b>
                          </p>
                          <p
                            className="m-1"
                            style={{ fontSize: "12.5px", color: "black" }}
                          >
                            Customer Code (Ref.1) :&nbsp;
                            <b>
                              {dataInfoCompany?.bill.bank.prefix_ref1}
                              {dataInfoCustomer?.customer_code}
                            </b>
                          </p>
                          <p
                            className="m-1"
                            style={{ fontSize: "12.5px", color: "black" }}
                          >
                            Contract No. (Ref.2) :&nbsp;
                            <b>
                              {dataInfoCompany?.bill.bank.prefix_ref1}
                              {dataInfoInvoice?.contract_no}
                            </b>
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <table
                      style={{
                        border: 0,
                        fontSize: "12px",
                        color: "black",
                        minWidth: "100%",
                      }}
                    >
                      <label style={{ color: "black" }}>ชำระโดย</label>
                      <tbody className="text-center">
                        <tr width="100%">
                          <td
                            style={{
                              border: "1px solid black",
                              borderRight: 0,
                              borderBottom: 0,
                            }}
                            className="p-2"
                            width="120px"
                          >
                            เงินสด / CASH
                          </td>
                          <td
                            style={{
                              border: "1px solid black",
                              borderRight: 0,
                              borderBottom: 0,
                            }}
                            className="p-2"
                            width="15%"
                          >
                            เลขที่เช็ค / CHEQUE NO.
                          </td>
                          <td
                            style={{
                              border: "1px solid black",
                              borderRight: 0,
                              borderBottom: 0,
                            }}
                            className="p-2"
                            width="15%"
                          >
                            เช็คลงวันที่ / DATE
                          </td>
                          <td
                            style={{
                              border: "1px solid black",
                              borderRight: 0,
                              borderBottom: 0,
                            }}
                            className="p-2"
                            width="20%"
                          >
                            ชื่อธนาคาร / BANK NAME
                          </td>
                          <td
                            style={{
                              border: "1px solid black",
                              borderRight: 0,
                              borderBottom: 0,
                            }}
                            className="p-2"
                            width="20%"
                          >
                            สาขา / BRANCH
                          </td>
                          <td
                            style={{
                              border: "1px solid black",
                              borderBottom: 0,
                            }}
                            className="p-2"
                            width="200px"
                          >
                            จำนวนเงิน / AMOUNT
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid black",
                              borderRight: 0,
                              borderBottom: 0,
                            }}
                            className="p-2"
                            height="40px"
                          >
                            เช็ค / CHEQUE
                          </td>
                          <td
                            style={{
                              border: "1px solid black",
                              borderRight: 0,
                              borderBottom: 0,
                            }}
                            className="p-2"
                          ></td>
                          <td
                            style={{
                              border: "1px solid black",
                              borderRight: 0,
                              borderBottom: 0,
                            }}
                            className="p-2"
                          ></td>
                          <td
                            style={{
                              border: "1px solid black",
                              borderRight: 0,
                              borderBottom: 0,
                            }}
                            className="p-2"
                          ></td>
                          <td
                            style={{
                              border: "1px solid black",
                              borderRight: 0,
                              borderBottom: 0,
                            }}
                            className="p-2"
                          ></td>
                          <td
                            style={{
                              border: "1px solid black",
                              borderBottom: 0,
                            }}
                            className="p-2"
                          ></td>
                        </tr>
                        <tr>
                          <td
                            style={{ border: "1px solid black" }}
                            className="text-left pl-3"
                            colSpan="6"
                            height="40px"
                          >
                            จำนวนเงินเป็นตัวอักษร (บาท) / IN WORDS (THB)
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="row">
                      <Col
                        xs={9}
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          marginTop: "1rem",
                        }}
                      >
                        {dataInfoCompany?.bill.bank.bank_detail.map((doc) => {
                          return (
                            <div
                              className="mr-1"
                              style={{            
                                fontSize: "11px",
                                color: "black",
                                lineHeight: "100%",
                              }}
                            >
                              <img
                                src={
                                  props.bankPayment.length != 0 &&
                                  doc.id_bank_bill != ""
                                    ? `data:image/png;base64,${
                                        props.bankPayment.find(
                                          (doc1) =>
                                            doc1.id_bank == doc.id_bank_bill
                                        )?.bank_icon_noBG ?? ""
                                      }`
                                    : null
                                }
                                width="auto"
                                height="20"
                              />
                              &nbsp;
                              {props.bankPayment.length != 0 &&
                              doc.id_bank_bill != ""
                                ? props.bankPayment.find((doc1) => doc1.id_bank == doc.id_bank_bill)?.name_bank_th ?? "N/A"
                                : null}{" "}
                              เลขที่บัญชี {formatNumBank(doc.bank_num)}{" "}
                              (Comp.code : {doc.bank_comp_code})
                            </div>
                          );
                        })}
                      </Col>
                      <Col>
                        <table
                          border="1"
                          style={{
                            marginTop: "1rem",
                            fontSize: "12px",
                            color: "black",
                            minWidth: "100%",
                          }}
                        >
                          <tbody className="text-center">
                            <tr>
                              <td
                                style={{ border: "1px solid black" }}
                                width="300px"
                                height="30px"
                              >
                                เจ้าหน้าที่ธนาคารผู้รับเงิน
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid black",
                                  borderTop: 0,
                                }}
                                height="40px"
                              ></td>
                            </tr>
                          </tbody>
                        </table>
                      </Col>
                    </div>
                    <p
                      style={{
                        marginTop: "1rem",
                        fontSize: "12px",
                        color: "black",
                      }}
                    >
                      ผู้นำฝาก (Name of deposit)
                      ………………………………………………………….(ตัวบรรจง) โทร (Tel
                      No.)………………………………………………………….
                      <br />
                      ท่านสามารถนำใบแจ้งชำระเงินนี้ไปชำระได้ที่เคาเตอร์ธนาคารตามที่ระบุไว้
                      ทุกสาขาทั่วประเทศ(โปรดรอรับหลักฐานการชำระเงินจากธนาคารและตรวจสอบความถูกต้องด้วยทุกครั้ง)
                    </p>
                  </div>

                  <br />
                  <div>
                    {dataInfoCompany?.bill.lotus.check ? (
                      <div style={{ fontSize: "12px", color: "black" }}>
                        สำหรับ LOTUS
                      </div>
                    ) : null}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: `${
                          dataInfoCompany?.bill.lotus.check
                            ? "space-between"
                            : "flex-end"
                        }`,
                        alignItems: "center",
                      }}
                    >
                      {dataInfoCompany?.bill.lotus.check ? (
                        <div>
                          <SVG
                            className="barCode"
                            src={dataInfoInvoice?.barcode_tesco}
                            style={{ width: "350px", display: "none" }}
                          />

                          <div style={{ border: "1px solid black" }}>
                            <div style={{ transform: "scale(0.9)" }}>
                              <Barcode
                                value={$('[class="barCode"]')
                                  .find("title")
                                  .first()
                                  .html()}
                                height="42"
                                width="1"
                                fontSize="12px"
                              />
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {dataInfoCompany?.bill.bank.check ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            <div style={{ transform: "scale(0.9)" }}>
                              <Barcode
                                value={`|${dataInfoCompany?.id_tax}${
                                  dataInfoCompany?.bill.bank.suffix_key
                                }\r${dataInfoCompany?.bill.bank.prefix_ref1}${
                                  dataInfoCustomer?.customer_code
                                }\r${dataInfoCompany?.bill.bank.prefix_ref2}${
                                  dataInfoInvoice?.contract_no
                                }\r${parseFloat(dataInfoInvoice?.total_amount)
                                  .toFixed(2)
                                  .toString()
                                  .split(".")
                                  .join("")}`}
                                height="42"
                                width="1"
                                fontSize="12px"
                              />
                            </div>
                          </div>
                          <div>
                            <QRCode
                              value={`|${dataInfoCompany?.id_tax}${
                                dataInfoCompany?.bill.bank.suffix_key
                              }\r${dataInfoCompany?.bill.bank.prefix_ref1}${
                                dataInfoCustomer?.customer_code
                              }\r${dataInfoCompany?.bill.bank.prefix_ref2}${
                                dataInfoInvoice?.contract_no
                              }\r${parseFloat(dataInfoInvoice?.total_amount)
                                .toFixed(2)
                                .toString()
                                .split(".")
                                .join("")}`}
                              className="ml-5 mr-3"
                              style={{ height: "80px", width: "auto" }}
                            />
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              ) : null}
              <br />
            </div>

          </Card.Body>
        </Card>
        <Form className="mt-3">
          <Form.Group>
            <Row
              className="align-items-center"
              style={{
                display: "flex",
                alignItems: "center",
                padding: "10px",
              }}
            >
              <Col xs={1} style={{ display: "flex", justifyContent: "center" }}>
                {dataInfoInvoice?.status == "Pending" ? (
                  <>
                    <Form.Check
                      type="checkbox"
                      checked={agreePay}
                      onChange={() => setagreePay(!agreePay)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    />
                  </>
                ) : (
                  <>
                    <Form.Check
                      type="checkbox"
                      checked={true}
                      disabled={true}
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    />
                  </>
                )}
              </Col>
              <Col style={{ paddingLeft: "0" }}>
                <Form.Label
                  style={{
                    margin: "0",
                    color: "#003581",
                    fontSize: "14px",
                    lineHeight: "1.5",
                  }}
                >
                  I agree to the{" "}
                  <span
                    style={{
                      color: "#D33D4C",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setpolicy_subject("Terms And Conditions");
                      setpolicy_content({
                        text: dataInfoCustomer?.terms_conditions,
                        date: dataInfoCustomer?.terms_conditions_issue_date,
                      });
                      setpolicy_text({
                        th: "เงื่อนไขการให้บริการ",
                        en: "TERMS & CONDITIONS",
                      });
                      setmodalShowPolicy(true);
                    }}
                  >
                    terms and conditions
                  </span>
                  , the{" "}
                  <span
                    style={{
                      color: "#D33D4C",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setpolicy_subject("Privacy Policy");
                      setpolicy_content({
                        text: dataInfoCustomer?.privacy_policy,
                        date: dataInfoCustomer?.privacy_policy_issue_date,
                      });
                      setpolicy_text({
                        th: "นโยบายความเป็นส่วนตัว",
                        en: "PRIVACY POLICY",
                      });
                      setmodalShowPolicy(true);
                    }}
                  >
                    privacy policy
                  </span>
                  , and the{" "}
                  <span
                    style={{
                      color: "#D33D4C",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setpolicy_subject("Refundable Policy");
                      setpolicy_content({
                        text: dataInfoCustomer?.refundable_policy,
                        date: dataInfoCustomer?.refundable_policy_issue_date,
                      });
                      setpolicy_text({
                        th: "นโยบายการคืนเงิน",
                        en: "REFUNDABLE POLICY",
                      });
                      setmodalShowPolicy(true);
                    }}
                  >
                    refundable policy
                  </span>
                  .
                </Form.Label>
              </Col>
            </Row>
          </Form.Group>
        </Form>
        <div style={{ display: "flex", textAlign: "center" }}>
          <ReactToPrint
            trigger={() => (
              <Button
                className="mr-2"
                name="btn_close"
                variant="link"
                onClick={0}
                style={{
                  color: "#003581",
                  border: "1px solid #D33D4C",
                  borderRadius: "10px",
                  width: "150px",
                  textDecoration: "none",
                }}
              >
                Print
              </Button>
            )}
            content={() => ref.current}
          />
          {(dataInfoCompany?.cash?.check ||
            dataInfoCompany?.credit?.enable ||
            dataInfoCompany?.paypal?.enable ||
            dataInfoCompany?.bill?.enable ||
            dataInfoCompany?.transfer?.enable) &&
          dataInfoInvoice?.status == "Pending" ? (
            <Button
              name="btn_save"
              variant="danger"
              onClick={() => isVerified ? setmodalShowPayment(true) : setmodalShowVerifyId(true)}
              style={{ borderRadius: "10px", width: "150px" }}
              disabled={!agreePay}
            >
              Agree And Pay
            </Button>
          ) : null}
        </div>
        </div>

        {/* ── Modal ยืนยัน Tax ID / บัตรประชาชน ── */}
        <Modal
  show={modalShowVerifyId}
  onHide={() => {}}
  centered
  backdrop="static"
  keyboard={false}
>
  <Modal.Header
    style={{
      padding: "0 24px",
      borderBottom: "1px solid #dee2e6",
      height: "70px",
      display: "flex",
      alignItems: "center",
    }}
  >
    <Modal.Title style={{ fontSize: "16px", color: "#003581" }}>
      ตรวจสอบตัวตนผู้รับใบแจ้งหนี้
    </Modal.Title>
  </Modal.Header>
  <Modal.Body style={{ padding: "16px 24px" }}>
    <p style={{ fontSize: "14px", color: "#555", marginBottom: "12px" }}>
      {dataInfoCustomer?.detail_type === "personal"
        ? "กรุณากรอกเลขบัตรประชาชน หรือหมายเลข Passport"
        : "กรุณากรอกเลขประจำตัวผู้เสียภาษี (Tax ID) 13 หลัก"}
    </p>
    <Form.Control
      type="text"
      placeholder={
        dataInfoCustomer?.detail_type === "personal"
          ? "บัตรประชาชน / Passport"
          : "Tax ID 13 หลัก"
      }
      value={verifyIdInput}
      onChange={(e) => {
        setVerifyIdInput(e.target.value);
        setVerifyIdError("");
      }}
      style={{ borderRadius: "8px" }}
      isInvalid={!!verifyIdError}
      maxLength={dataInfoCustomer?.detail_type === "personal" ? 20 : 13}
    />
    {verifyIdError && (
      <div style={{ color: "#D33D4C", fontSize: "13px", marginTop: "6px" }}>
        {verifyIdError}
      </div>
    )}
  </Modal.Body>
  <Modal.Footer
    style={{
      padding: "0 24px",
      borderTop: "1px solid #dee2e6",
      height: "70px",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      margin: 0,
    }}
  >
    <Button
      variant="danger"
      style={{ borderRadius: "8px", margin: 0 }}
      onClick={() => {
        const isPersonal = dataInfoCustomer?.detail_type === "personal";
        const expected = isPersonal
          ? dataInfoCustomer?.id_passport
          : dataInfoCustomer?.id_tax;
        if (!verifyIdInput.trim()) {
          setVerifyIdError("กรุณากรอกข้อมูล");
          return;
        }
        if (verifyIdInput.trim() !== String(expected).trim()) {
          setVerifyIdError("ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง");
          return;
        }
        setIsVerified(true);
        setmodalShowVerifyId(false);
        setVerifyIdInput("");
        setVerifyIdError("");
      }}
    >
      ยืนยัน
    </Button>
  </Modal.Footer>
</Modal>

      </StyledWrapper>

      <ModalPolicy
        show={modalShowPolicy}
        onHide={() => setmodalShowPolicy(false)}
        subject={policy_subject}
        text={policy_text}
        content={policy_content}
        company={dataInfoCompany}
      />

      <ModalPayment
        show={modalShowPayment}
        onHide={() => setmodalShowPayment(false)}
        company={dataInfoCompany}
        bankPayment={props.bankPayment}
        selectCreditBank={props.selectCreditBank}
        customerINvoice={[{
          total:                 dataInfoInvoice.total,
          invoice_no:            dataInfoInvoice.invoice_no,
          id_invoiceproject:     dataInfoInvoice.invoice_no,
          id_contract_agreement: dataInfoInvoice.id_contract_agreement,
          id_project:            id_project,
          total_price:           dataInfoInvoice.total_amount,
        }]}
        onSendOmise={(charges, callback) => {
          console.log("sendOmise", charges);
          sendOmise.mutate(charges, {
            onSuccess: () => {
              console.log("ส่งสำเร็จ");
              callback && callback(true);
            },
            onError: (err) => {
              console.log("error", err);
              callback && callback(false);
            },
          });
        }}
        onSendBillSlip={(data, callback) => {
          sendBillSlip.mutate(data, {
            onSuccess: () => {
              console.log("ส่งสำเร็จ");
              callback && callback(true);
            },
            onError: (err) => {
              console.log("error", err);
              callback && callback(false);
            },
          });
        }}
        // onSendBillSlipInvoice={(data) => {
        //   console.log("sendBillSlipInvoice", data);
        //   alert("onSendBillSlipInvoice ยังไม่พร้อมใช้งานในขณะนี้");
        //   // TODO: เรียก API
        // }}
      />



        

    </>
  );
};

export default BillingProject;